import { defineStore } from "pinia";
import { ref } from "vue";

/**
 * Dialog HITL „usunąć kontakt Google?" (docs/integrations/pilot-contacts.md §4).
 * Otwierany przez event `lead:google-contact-prompt` (api/leads.ts) — ten sam wzorzec
 * decoupling co auth:logout/api:rate-limit w App.vue.
 */
export const useGoogleCleanupStore = defineStore("googleCleanup", () => {
  const leadId = ref<number | null>(null);

  function open(id: number): void {
    leadId.value = id;
  }

  function close(): void {
    leadId.value = null;
  }

  return { leadId, open, close };
});
